import React, { useEffect, useMemo, useState, useCallback } from "react"
import { useDebounce } from "hooks/useDebounce"
import { withRouter } from "react-router-dom"
import TableContainer from "components/Common/TableContainer"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import * as url from "../../helpers/url_helper"

import { Name, Description } from "./brandlistCol"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
// import DeleteModal from "components/Common/DeleteModal"

import { getBrands as onGetBrands, clearBrands } from "store/brands/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import AccessControlWrapper from "components/Common/PermissionButton"
import { PageTitle } from "constants/ui"
import CButton from "components/Common/CButton"
import IconButton from "components/Common/IconButton"
import { getFirstTabPermission } from "helpers/tab_helper"

const BrandsList = props => {
    //meta title
    document.title = PageTitle.BRAND_DETAIL

    const [search, setSearch] = useState("")
    const [page, setPage] = useState(1)

    const dispatch = useDispatch()

    const { history } = props

    const { data, userMenu } = useSelector(state => ({
        data: state.brands,
        userMenu: state.userMenu?.userMenu || [],
    }))

    const firstTabPermission = getFirstTabPermission("BRAND_DETAIL", userMenu)


    const columns = useMemo(
        () => [
            {
                Header: "Logo",
                accessor: "logo",
                disableFilters: true,
                filterable: true,

                accessor: cellProps => (
                    <>
                        {!cellProps.logo ? (
                            <div className="avatar-xs">
                                <span className="avatar-title rounded-circle">
                                    {cellProps.name.charAt(0)}
                                </span>
                            </div>
                        ) : (
                            <div>
                                <img
                                    className="rounded-circle avatar-xs"
                                    src={cellProps.logo}
                                    alt=""
                                />
                            </div>
                        )}
                    </>
                ),
            },
            {
                Header: "Name",
                accessor: "name",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <Name {...cellProps} />
                },
            },
            {
                Header: "Description",
                accessor: "description",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <Description {...cellProps} />
                },
            },
            {
                Header: "Action",
                Cell: cellProps => {
                    return (
                        <AccessControlWrapper
                            actionType={firstTabPermission?.actionType || "get"}
                            contextUri={firstTabPermission?.contextUri || url.GET_BRANDS}
                            history={history}
                        >
                            <IconButton.View onClick={() => rowClick(null, cellProps.row)} />
                        </AccessControlWrapper >
                    )
                },
            },
        ],
        []
    )

    // Load fresh brands data when component mounts
    useEffect(() => {
        dispatch(
            onGetBrands({
                headers: {
                    "input-parameters": {},
                },
                pagination: { startIndex: 0 },
            })
        )
    }, [dispatch])

    // Clear brands and search when component unmounts
    useEffect(() => {
        return () => {
            dispatch(clearBrands())
        }
    }, [dispatch])

    const rowClick = (e, row) => {
        const {
            original: { brandID },
        } = row
        history.push({
            pathname: `/brands/${brandID}`,
        })
    }

    function handleAddBrandClick() {
        history.push("/brands/add-brand")
    }

    const dispatchSearch = useCallback((value) => {
        setPage(1)
        dispatch(
            onGetBrands({
                headers: {
                    "input-parameters": { keyword: value || "" },
                },
                pagination: { startIndex: 0 },
            })
        )
    }, [dispatch])

    const [debouncedSearch] = useDebounce(dispatchSearch)

    const handleSearchChange = e => {
        const { value } = e.target
        setSearch(value)
        debouncedSearch(value)
    }

    const handlePageChange = page => {
        const startIndex = (page - 1) * 10 // Assuming page size is 10
        setPage(page)
        dispatch(
            onGetBrands({
                headers: {
                    "input-parameters": { keyword: search || "" },
                },
                pagination: { startIndex },
            })
        )
    }

    const handleRefresh = () => {
        dispatch(
            onGetBrands({
                headers: {
                    "input-parameters": { keyword: search || "" },
                },
                pagination: { startIndex: (page - 1) * 10 },
            })
        )
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* <AccessControlWrapper
            actionType={"view"}
            contextUri={url.GET_BRANDS}
            history={history}
          ></AccessControlWrapper> */}
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs
                        title={PageTitle.BRAND_LIST}
                        titleLink="/brands"
                        breadcrumbItem={PageTitle.BRAND_LIST}

                    />
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md="6">
                                            <div>
                                                <input
                                                    type="text"
                                                    placeholder="search brands"
                                                    onChange={handleSearchChange}
                                                    className="form-control w-50 rounded-pill"
                                                />
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="text-sm-end">
                                                <AccessControlWrapper
                                                    actionType={"post"}
                                                    contextUri={url.MANAGE_BRAND}
                                                    history={history}
                                                >
                                                    <CButton.Primary
                                                        icon="mdi mdi-plus-circle-outline"
                                                        text="Add Brand"
                                                        className="mb-2 me-2"
                                                        onClick={handleAddBrandClick}
                                                    />
                                                </AccessControlWrapper>
                                            </div>
                                        </Col>
                                    </Row>

                                    <TableContainer
                                        columns={columns}
                                        data={data?.error?.message ? [] : data.brands}
                                        isGlobalFilter={false}
                                        isAddUserList={true}
                                        rowClick={rowClick}
                                        protectedRowClick={true}
                                        contextUri={url.GET_BRANDS}
                                        actionType="get"
                                        handleAddButtonClick={handleAddBrandClick}
                                        customPageSize={10}
                                        className="custom-header-css"
                                        columnFilter={false}
                                        changePageSize={false}
                                        isAddButtonText="Add Brand"
                                        onPageChange={handlePageChange}
                                        currentPage={page}
                                        hasNextPage={!data?.error?.message && data.brands?.length >= 10}
                                        onRefresh={handleRefresh}
                                        refreshContextUri={url.GET_BRANDS}
                                        refreshActionType="get"
                                        history={history}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(BrandsList)
